var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiper"},[_c('div',{staticClass:"swiper-wrapper"},[_vm._t("default")],2),(_vm.navigation)?_c('div',{staticClass:"swiper-button-prev"}):_vm._e(),(_vm.navigation)?_c('div',{staticClass:"swiper-button-next"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }